import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetLines } from '@/hooks/useGetLines';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

const { useWatch } = Form;

export function LineFormItem(): JSX.Element {
	const organization_id = useWatch('organization_id');
	const company_id = useWatch('company_id');
	const sector_id = useWatch('sector_id');

	const { isLoading: isLoadingLines, data: lines = [] } = useGetLines({
		organization_id,
		company_id,
		sector_id
	});

	const isDisabled = !organization_id || !company_id || !sector_id;
	const isLoading = !!organization_id && !!company_id && !!sector_id && isLoadingLines;

	return (
		<FormItemWrapper name="line_id" label={I18n.get('Line')} labelCol={{ span: 24 }} dependencies={['workstation_id']}>
			<SelectOptions
				allowClear
				options={lines}
				loading={isLoading}
				disabled={isDisabled}
				placeholder={I18n.get('Line')}
			/>
		</FormItemWrapper>
	);
}
